module.exports = __webpack_public_path__ + "static/media/icon_area-chart.b087506b.svg";